import React, { FC, useMemo } from "react";

import { useLabels } from "../../contexts/labels";
import { renameFields } from "../../utils/object";
import { WhatsNextFinder, WhatsNextFinderProps } from "./whats-next-finder";

export interface WhatsNextFinderSectionProps {
  items: Queries.WhatsNextDataFragment[];
}

export const WhatsNextFinderSection: FC<WhatsNextFinderSectionProps> = ({ items }) => {
  const whatsNextItems = useMemo(() => {
    return items.filter(({ image }) => image?.gatsbyImageData);
  }, [items]);

  const { labels: stringLabels } = useLabels();

  const fieldsToRename: Record<keyof WhatsNextFinderProps["labels"], string | null> = {
    "whats-next-finder-header-filter": null,
    "whats-next-finder-panel-apply-filters": null,
    "whats-next-finder-panel-clear-filters": null,
    "whats-next-finder-panel-order-by": null,
    "whats-next-grid-empty-state": null,
    "whats-next-finder-panel-order-by-more-recent": null,
    "whats-next-finder-panel-order-by-less-recent": null,
    "whats-next-finder-panel-search": null,
    "whats-next-finder-panel-category": null,
    "whats-next-finder-panel-all-categories": null,
  };

  const labels = renameFields(stringLabels, fieldsToRename) as WhatsNextFinderProps["labels"];

  return (
    <WhatsNextFinder
      filterSearchParamKey="filter-whatsnext"
      whatsNextItems={whatsNextItems}
      labels={labels}
    />
  );
};
